import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--pdf-download"
export default class extends Controller {
  static values = {
    targetId: Number,
    path: String,
  };

  connect() {}

  download(e) {
    e.preventDefault();

    const href = `${this.pathValue}?id=${this.targetIdValue}`;
    document.dispatchEvent(new CustomEvent("resumin--pdf-download:downloaded"));
    window.location.href = href;
  }
}
